import { Subject, Observable } from 'rxjs'
import { OnDestroy } from '@angular/core'

export class UnsubscribesOnDestroy implements OnDestroy {
  private _destroy$: Subject<void> = new Subject()

  protected get destroy$(): Observable<void> {
    return this._destroy$.asObservable()
  }

  constructor() {}

  ngOnDestroy() {
    this._destroy$.next()
    this._destroy$.complete()
  }
}
